import { ledetekst } from '../diverse/Ledetekst';

export const EPOST_REGEX =
	/^[a-zA-Z0-9æøåÆØÅ._%+-]+@[a-zA-Z0-9æøåÆØÅ.-]+\.[a-zA-ZæøåÆØÅ]{2,}$/;
export const TELEFONNUMMER_REGEX = /^(((\+|00)[0-9]{1,15})|[0-9]{5}|[0-9]{8})$/;

export class Gyldighet {
	constructor() {
		this._instans = this;
		this._lager = {};
		this._sjekk = [];
	}
	egendefinert(gyldighet, obligatoriskhet, irettesettelse) {
		const kopi = new Gyldighet();
		kopi._instans = this._instans;
		kopi._sjekk = [
			...this._sjekk,
			{
				gyldighet: gyldighet,
				obligatoriskhet: obligatoriskhet,
				irettesettelse: irettesettelse,
			},
		];
		return kopi;
	}
	epostadresse() {
		return this.egendefinert(
			(verdi) => !!String(verdi || '').match(EPOST_REGEX),
			() => true,
			() => ['arbeidsvarsling.frontendkomponenter.Gyldighet.epostadresse']
		);
	}
	maks(lengde) {
		return this.egendefinert(
			(verdi) => parseInt(verdi || 0) <= lengde,
			() => true,
			(lengde) => [
				'arbeidsvarsling.frontendkomponenter.Gyldighet.maks',
				parseInt(lengde || 0),
				lengde,
			]
		);
	}
	makslengde(maks) {
		this._instans._makslengde = maks;
		return this.egendefinert(
			(verdi) => String(verdi || '').length <= maks,
			() => true,
			(verdi) => [
				'arbeidsvarsling.frontendkomponenter.Gyldighet.makslengde',
				String(verdi || '').length,
				maks,
			]
		);
	}
	obligatorisk() {
		return this.egendefinert(
			(verdi) => String(verdi || '').length > 0,
			(verdi) => String(verdi || '').length > 0,
			() => ['arbeidsvarsling.frontendkomponenter.Gyldighet.obligatorisk']
		);
	}

	antallVedlegg(min, maks) {
		return this.egendefinert(
			({ antallFiler }) => {
				return min <= antallFiler && antallFiler <= maks;
			},
			({ antallFiler }) => {
				return min <= antallFiler;
			},
			() => {
				if (min === maks) {
					return [
						'arbeidsvarsling.frontendkomponenter.Gyldighet.vedlegg.obligatorisk',
						min,
					];
				}
				return [
					'arbeidsvarsling.frontendkomponenter.Gyldighet.vedlegg.minmaks',
					min,
					maks,
				];
			}
		);
	}

	storrelseVedlegg(maks) {
		return this.egendefinert(
			({ totalStorrelse }) => {
				if (!totalStorrelse) {
					return true;
				}
				return totalStorrelse <= maks;
			},
			() => true,
			({ totalStorrelse }) => {
				return [
					'arbeidsvarsling.frontendkomponenter.Gyldighet.vedlegg.storrelse',
					leseligFilStorrelse(totalStorrelse),
					leseligFilStorrelse(maks),
				];
			}
		);
	}

	telefonnummer() {
		return this.egendefinert(
			(verdi) => !!String(verdi || '').match(TELEFONNUMMER_REGEX),
			() => true,
			() => [
				'arbeidsvarsling.frontendkomponenter.Gyldighet.telefonnummer',
			]
		);
	}
	sett(felt, verdi) {
		this._instans._lager[felt.id] = {
			instans: felt,
			mangler: this._sjekk
				.map((par) => {
					if (par.gyldighet(verdi)) {
						return;
					}
					let mangel = par.irettesettelse(verdi);
					mangel.unshift(par.obligatoriskhet(verdi));
					return mangel;
				})
				.filter((i) => Array.isArray(i) && i.length > 1),
			sendt: false,
		};
	}
	slett(felt) {
		delete this._instans._lager[felt.id];
	}
	static _erMangelObligatorisk(mangel) {
		return !mangel[0];
	}
	sjekkFelt(felt, ignorerSendt, ignorerObligatorisk) {
		if (!this._instans._lager[felt.id].sendt && !ignorerSendt) {
			return [];
		}
		let obligatorisk = false;
		let mangler = this._instans._lager[felt.id].mangler.filter((m) => {
			if (Gyldighet._erMangelObligatorisk(m)) {
				if (obligatorisk) {
					return false;
				}
				obligatorisk = true;
			}
			return true;
		});
		if (mangler.some(Gyldighet._erMangelObligatorisk)) {
			if (ignorerObligatorisk) {
				return [];
			} else if (mangler.length > 1) {
				mangler = mangler.filter(
					(m) => !Gyldighet._erMangelObligatorisk(m)
				);
			}
		}
		return this._omformTekster(mangler);
	}
	sjekkAlle(ignorerObligatorisk) {
		var mangler = Object.values(this._instans._lager)
			.map((felt) =>
				this.sjekkFelt(felt.instans, true, ignorerObligatorisk)
			)
			.flat();
		if (mangler.length > 0) {
			(
				(this.skjema || { ytreSkjema: undefined }).ytreSkjema || {
					stopp: () => undefined,
				}
			).stopp();
			Object.keys(this._instans._lager).forEach((felt) => {
				if (!ignorerObligatorisk) {
					this._instans._lager[felt].sendt = true;
				}
				this._instans._lager[felt].instans.forceUpdate();
			});
		} else {
			(
				(this.skjema || { ytreSkjema: undefined }).ytreSkjema || {
					fortsett: () => undefined,
				}
			).fortsett();
		}
		return mangler;
	}
	_omformTekster(mangler) {
		return mangler.map((m1) => {
			let m2 = m1.slice(0);
			m2.shift();
			return ledetekst.getTekst(...m2);
		});
	}
	getMakslengde() {
		return this._instans._makslengde;
	}
}

export function leseligFilStorrelse(bytes, rundNed = false) {
	const thresh = 1024;
	if (Math.abs(bytes) < thresh) {
		return bytes + ' B';
	}
	const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	let u = -1;
	do {
		bytes /= thresh;
		++u;
	} while (Math.abs(bytes) >= thresh && u < units.length - 1);
	if (rundNed) {
		bytes = Math.floor(bytes * 10) / 10; // runder alltid ned tallet bak første komma
	} else {
		bytes = Math.ceil(bytes * 10) / 10; // runder alltid opp tallet bak første komma
	}
	return bytes.toFixed(1) + ' ' + units[u];
}
